import { useEffect, useState } from 'react';

export function useIsGoogleIma(): boolean {
  const [isGoogleImaSdkReady, setIsGoogleImaSdkReady] =
    useState<boolean>(false);

  useEffect(() => {
    if (getIsGoogleIma()) {
      setIsGoogleImaSdkReady(true);
      return;
    }

    try {
      const scripts = Array.from(document.querySelectorAll('script'));
      scripts.forEach((script) => {
        if (!script?.src) return;
        if (script.src === googleImaSdkScriptSrc) {
          setIsGoogleImaSdkReady(true);
          return;
        }
      });
    } catch (e) {}
  }, []);

  return isGoogleImaSdkReady;
}

export function getIsGoogleIma(): boolean {
  // @ts-ignore
  const isGoogle: boolean = window.google;
  // @ts-ignore
  const isGoogleIma: boolean = window.google?.ima;
  return isGoogle && isGoogleIma;
}

export const googleImaSdkScriptSrc: string =
  '//imasdk.googleapis.com/js/sdkloader/ima3.js';
